// @ts-check

export const BRANDING_TIMEOUT_MS = 8000;

/**
 * @param {(url: string, init?: { signal?: AbortSignal, headers?: Record<string, string> }) => Promise<{ ok: boolean, status: number, json: () => Promise<unknown> }>} fetchImpl
 * @param {number} [timeoutMs]
 */
export async function fetchBranding(fetchImpl, timeoutMs = BRANDING_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetchImpl("/api/config/branding", {
      signal: controller.signal,
      headers: { Accept: "application/json" },
    });
    if (!response.ok) return { ok: false, reason: `status ${response.status}` };
    /** @type {unknown} */
    let body;
    try {
      body = await response.json();
    } catch {
      return { ok: false, reason: "invalid json" };
    }
    if (!body || typeof body !== "object" || Array.isArray(body)) return { ok: false, reason: "bad shape" };
    const row = /** @type {Record<string, unknown>} */ (body);
    if (!Array.isArray(row.brands)) return { ok: false, reason: "bad shape" };
    for (const brand of row.brands) {
      if (!brand || typeof brand !== "object" || Array.isArray(brand)) return { ok: false, reason: "bad shape" };
      if (typeof /** @type {Record<string, unknown>} */ (brand).name !== "string") return { ok: false, reason: "bad shape" };
    }
    const themes = Array.isArray(row.themes) ? row.themes : [];
    return { ok: true, brands: row.brands, themes };
  } catch (error) {
    const name = error && typeof error === "object" && "name" in error ? String(error.name) : "";
    if (name === "AbortError") return { ok: false, reason: "timeout" };
    return { ok: false, reason: "network" };
  } finally {
    clearTimeout(timer);
  }
}

/**
 * @param {(url: string, init: { method: string, headers: Record<string, string>, body: string }) => Promise<{ ok: boolean }>} fetchImpl
 * @param {string} userId
 * @param {string} env
 * @param {string | null} themeId
 */
export async function saveThemePreference(fetchImpl, userId, env, themeId) {
  const response = await fetchImpl(
    `/api/usermapping/${encodeURIComponent(userId)}/theme?env=${encodeURIComponent(env)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ themePreference: themeId }),
    },
  );
  return response.ok;
}
